import type { UserPreferencesNotificationsSectionActionsProps } from "./user-preferences-notifications-section-actions.type";

import { UserPreferencesNotificationsDropdown } from "../user-preferences-notifications-dropdown";

import { useUserPreferencesNotificationsSectionActions } from "./user-preferences-notifications-section-actions.hook";

export const UserPreferencesNotificationsSectionActions = (
  props: UserPreferencesNotificationsSectionActionsProps
) => {
  const { menuItems, onMenuItemClick } =
    useUserPreferencesNotificationsSectionActions(props);

  return (
    <UserPreferencesNotificationsDropdown
      menuItems={menuItems}
      onMenuItemClick={onMenuItemClick}
      type="text"
      shape="circle"
    />
  );
};
